export default __webpack_public_path__ + "static/media/maxdome_more_info_small.vp9.19f245e4.webm";